import Image from 'next/image'
import { FC } from 'react'

import { BankData } from '@/screens/Credit/page/types'
import ConditionsNotation from '@/screens/Credit/page/ui/CreditConditionsBlock/ConditionsNotation/ConditionsNotation'
import InfoCloud from '@/screens/Credit/page/ui/InfoCloud/InfoCloud'
import Tip from '@/screens/Credit/page/ui/Tip/Tip'

import { Question } from '@/shared/lib/@deprecated/iport-icons'

import cl from './ConditionsItem.module.scss'

const ConditionsItem: FC<{ item: BankData }> = ({ item }) => {
	return (
		<li className={cl.conditions__item}>
			<div className={cl.conditions__contentContainer}>
				<h3 className={cl.conditions__itemTitle}>{item.title}</h3>
				<div className={cl.conditions__contentWrapper}>
					{
						<div className={cl.conditions__colWrapper}>
							<p className={cl.conditions__colTitle}>Банки-партнёры</p>
							{item.pic.extraBanks ? (
								<Tip
									Icon={
										<Image
											className={cl.conditions__icon}
											src={item.pic.src}
											alt={item.pic.alt}
											width={item.pic.width}
											height={item.pic.height}
											unoptimized
										/>
									}>
									{
										<Image
											className={cl.conditions__icon}
											src={item.pic.extraBanks.src}
											alt={item.pic.extraBanks.alt}
											width={item.pic.extraBanks.width}
											height={item.pic.extraBanks.height}
											unoptimized
										/>
									}
								</Tip>
							) : (
								<Image
									className={cl.conditions__icon}
									src={item.pic.src}
									alt={item.pic.alt}
									width={item.pic.width}
									height={item.pic.height}
									unoptimized
								/>
							)}
						</div>
					}
					<div className={cl.conditions__gridWrapper}>
						<div className={cl.conditions__colWrapper}>
							<p className={cl.conditions__colTitle}>Процентная ставка{item.title === 'Рассрочка' && ', от'}</p>
							<p className={cl.conditions__colSubtitle}>{item.percent}</p>
						</div>
						<div className={cl.conditions__colWrapper}>
							<p className={cl.conditions__colTitle}>Первый взнос</p>
							<p className={cl.conditions__colSubtitle}>{item.initialFee}</p>
						</div>

						<div className={cl.conditions__colWrapper}>
							<p className={cl.conditions__colTitle}>Сумма</p>
							<p className={cl.conditions__colSubtitle}>{item.sum}</p>
						</div>
						<div className={cl.conditions__colWrapper}>
							<p className={cl.conditions__colTitle}>Срок</p>
							{item.extraNode ? (
								<div className={cl.conditions__extraNodeWrapper}>
									<Tip
										tooltipPosition={'topLeft'}
										onXLPosition={'top'}
										Icon={
											<div className={cl.conditions__itemWrapper}>
												<p className={cl.conditions__colSubtitle}>{item.term}</p>
												<Question size={24} fill={'none'} />
											</div>
										}>
										{!!item.extraNode && <InfoCloud data={item.extraNode} />}
									</Tip>
								</div>
							) : (
								<p className={cl.conditions__colSubtitle}>{item.term}</p>
							)}
						</div>
					</div>
				</div>
			</div>
			<ConditionsNotation item={item} />
		</li>
	)
}

export default ConditionsItem
